import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import classNames from "classnames";
import Image from "next/image";
import { useRouter } from 'next/router';
import React from "react";

type ratingsType ={
  logo : string;
  rating : string;
}

type featureType = {
  text:string
}

export type WebinarDetailsProps = {
  data: {
    type?: string;
    heading?: string;
    headingType?: string;
    mainHeroHeader?:string;
    leadEndpointUrl?: string;
    defaultCountry?: string;
    ratings ?:ratingsType[];
    ctas: CtaType[];
    discountInfo?: string;
    features ?: featureType[]
  };
};

const WebinarDetails: React.FC<WebinarDetailsProps> = ({ data }) => {

  const router = useRouter();
  const isWebinarPath = router.asPath.includes('webinar');

  const ratings = [
     {
       logo: "/images/categories/home-testimonials/g2-crowd.svg",
       rating: "/images/categories/home-testimonials/rating-stars.svg",
     },
     {
       logo: "/images/categories/home-testimonials/capterra.svg",
       rating: "/images/categories/home-testimonials/rating-stars.svg",
     },
     {
       logo: "/images/categories/home-testimonials/trustpilot.svg",
       rating: "/images/categories/home-testimonials/rating-stars.svg",
     },
   ];
   

const finalRatings = data.ratings ? data.ratings : ratings;
  return (
    <div className="mx-auto mt-12 flex max-w-[1200px] flex-col items-center justify-between gap-8 px-5 lg:flex-row lg:px-[90px]">
      <div className="flex flex-col items-center">
        <div>
          <div className="flex flex-col gap-10 text-center sm:text-left">
            <p className="text-title-32 font-semibold sm:text-title40">
              {data?.heading}
            </p>
            <div className="flex flex-col gap-6">
              {data?.features &&
                data?.features?.map(({ text }: { text: string }) => {
                  return (
                    <div key={text} className="flex w-full items-start gap-1">
                      <div className="h-5 w-5">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.7578 12.9461C2.13062 11.3189 2.13062 8.68074 3.7578 7.05356L7.05363 3.75774C8.68081 2.13055 11.319 2.13055 12.9462 3.75773L16.242 7.05356C17.8692 8.68074 17.8692 11.3189 16.242 12.9461L12.9462 16.2419C11.319 17.8691 8.68081 17.8691 7.05363 16.2419L3.7578 12.9461Z"
                            stroke="#6059FF"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.0939 8.92236L9.47696 11.5393L7.90381 9.97113"
                            stroke="#6059FF"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <span className="text-body">{text}</span>
                    </div>
                  );
                })}
            </div>
            <div className="">
              <CtaButtonGroup
                align="sm:left"
                ctas={data?.ctas}
                affiliateButton={true}
              />
              {data?.discountInfo && (
                <div className="ml-6 mt-6 flex items-center justify-center gap-2 sm:justify-start">
                  <img
                    src="/images/icons/percentage-pink.svg"
                    alt="company logo"
                    className="h-4 w-4"
                  />
                  <p className="text-center text-body-12 font-normal text-grey-4">
                    {data?.discountInfo}
                    Hurry!{" "}
                    <span className="font-bold">Limited slots available</span>-
                    grab your seat now.
                  </p>
                </div>
              )}
              {isWebinarPath && (
                <div className="ml-6 mt-6 flex items-center justify-center gap-2 sm:justify-start">
                  <img
                    src="/images/icons/percentage-pink.svg"
                    alt="company logo"
                    className="h-4 w-4"
                  />
                  <p className="text-center text-body-12 font-normal text-grey-4">
                    Hurry!{" "}
                    <span className="font-bold">Limited slots available</span>-
                    grab your seat now.
                  </p>
                </div>
              )}
            </div>
            {data?.headingType !== "affiliate" && (
              <div className="flex justify-center sm:justify-start">
                {finalRatings?.map((company, idx) => (
                  <div
                    className={classNames(
                      `flex flex-col  items-end justify-between`,
                      idx === 0 ? "pr-4" : "px-4"
                    )}
                    key={company?.logo}
                  >
                    <img
                      src={company?.logo}
                      alt="company logo"
                      className="mb-1 h-5 w-24 lg:h-10"
                    />
                    <img src={company?.rating} alt="company rating" />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <Image
        src={data?.mainHeroHeader ?? "/images/ratings.png"}
        alt="main-hero-header"
        width={500}
        height={500}
      />
    </div>
  );
};
export default WebinarDetails;
